export const pinturaLabels = {
    annotateLabel: '',

    labelReset: '',
    labelDefault: '',
    labelAuto: '',
    labelNone: '',
    labelEdit: '',
    labelClose: '',
    labelSupportError: (features) => '',

    // defaults
    labelColor: '',
    labelWidth: '',
    labelSize: '',
    labelOffset: '',
    labelAmount: '',
    labelInset: '',
    labelRadius: '',

    // controls
    labelColorPalette: '',

    // sizes
    labelSizeExtraSmall: '',
    labelSizeSmall: '',
    labelSizeMediumSmall: '',
    labelSizeMedium: '',
    labelSizeMediumLarge: '',
    labelSizeLarge: '',
    labelSizeExtraLarge: '',

    // unused?
    labelButtonRevert: '',
    labelButtonCancel: '',
    labelButtonUndo: '',
    labelButtonRedo: '',
    labelButtonExport: '',

    // zoom
    labelZoomIn: '',
    labelZoomOut: '',
    labelZoomFit: '',
    labelZoomActual: '',

    // status
    statusLabelButtonClose: '',
    statusLabelLoadImage: (state) => '',

    // processing status message
    statusLabelProcessImage: (state) => '',

    shapeLabelButtonSelectSticker: '',

    shapeTitleButtonTextLayoutAutoWidth: '',
    shapeTitleButtonTextLayoutAutoHeight: '',
    shapeTitleButtonTextLayoutFixedSize: '',

    shapeTitleButtonFlipHorizontal: '',
    shapeTitleButtonFlipVertical: '',
    shapeTitleButtonRemove: '',
    shapeTitleButtonDuplicate: '',
    shapeTitleButtonMoveToFront: '',

    shapeLabelInputText: '',

    shapeLabelInputCancel: '',
    shapeLabelInputConfirm: '',

    shapeLabelStrokeNone: '',

    shapeLabelFontStyleNormal: '',
    shapeLabelFontStyleBold: '',
    shapeLabelFontStyleItalic: '',
    shapeLabelFontStyleItalicBold: '',

    shapeTitleBackgroundColor: '',
    shapeTitleCornerRadius: '',

    shapeTitleFontFamily: '',
    shapeTitleFontSize: '',
    shapeTitleFontStyle: '',
    shapeTitleLineHeight: '',

    shapeTitleLineStart: '',
    shapeTitleLineEnd: '',
    shapeTitleStrokeWidth: '',
    shapeTitleStrokeColor: '',

    shapeTitleLineDecorationBar: '',
    shapeTitleLineDecorationCircle: '',
    shapeTitleLineDecorationSquare: '',
    shapeTitleLineDecorationArrow: '',
    shapeTitleLineDecorationCircleSolid: '',
    shapeTitleLineDecorationSquareSolid: '',
    shapeTitleLineDecorationArrowSolid: '',

    shapeTitleColorTransparent: '',
    shapeTitleColorWhite: '',
    shapeTitleColorSilver: '',
    shapeTitleColorGray: '',
    shapeTitleColorBlack: '',
    shapeTitleColorNavy: '',
    shapeTitleColorBlue: '',
    shapeTitleColorAqua: '',
    shapeTitleColorTeal: '',
    shapeTitleColorOlive: '',
    shapeTitleColorGreen: '',
    shapeTitleColorYellow: '',
    shapeTitleColorOrange: '',
    shapeTitleColorRed: '',
    shapeTitleColorMaroon: '',
    shapeTitleColorFuchsia: '',
    shapeTitleColorPurple: '',

    shapeTitleTextColor: '',
    shapeTitleTextAlign: '',
    shapeTitleTextAlignLeft: '',
    shapeTitleTextAlignCenter: '',
    shapeTitleTextAlignRight: '',

    shapeLabelToolMove: '',
    shapeLabelToolView: '',
    shapeLabelToolSharpie: '',
    shapeLabelToolEraser: '',
    shapeLabelToolPath: '',
    shapeLabelToolRectangle: '',
    shapeLabelToolEllipse: '',
    shapeLabelToolArrow: '',
    shapeLabelToolLine: '',
    shapeLabelToolText: '',
    shapeLabelToolPreset: '',

    finetuneLabel: '',
    finetuneLabelBrightness: '',
    finetuneLabelContrast: '',
    finetuneLabelSaturation: '',
    finetuneLabelExposure: '',
    finetuneLabelTemperature: '',
    finetuneLabelGamma: '',
    finetuneLabelClarity: '',
    finetuneLabelVignette: '',
};
